<template>
  <div>
    dasdawe
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '90%', width: '100%' }"
    >
      <div style="height:100%;display:flex;flex-direction:column">
        <div class="text-light bg-secondary">
          <i
            @click="iframeReplay()"
            role="button"
            tabindex="0"
            class="van-icon van-icon-replay van-popup__close-icon van-popup__close-icon--top-right"
            style="right: 60px;"
          ></i>
          <h6 class="m-3">{{ title }}</h6>
        </div>
        <div style="flex-grow:1;">
          <iframe
            id="iframe"
            :src="url"
            scrolling="auto"
            frameborder="no"
          ></iframe>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";
Vue.use(Popup);
export default {
  name: "PopupWin",
  props: {
    show: {
      type: Boolean,
      default: true
    },
    url: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  mounted: function() {
    console.log(this.show, this.url, this.title);
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
